import { get } from 'services/ajax';

const FEATURE_FLAGS_API_ROOT = `${process.env.API_URL}/resource/v1`;
const FEATURE_FLAGS_TOGGLE_API_ROOT = `${process.env.API_URL}/mock/v1/feature-flag`;

export interface RawFeatureFlagsResponse {
  [flagName: string]: boolean | { value: boolean } | any;
}

export interface NormalizedFeatureFlagEntry {
  value: boolean;
}

export type NormalizedFeatureFlags = Record<string, NormalizedFeatureFlagEntry>;

function normalize(data: any): NormalizedFeatureFlags {
  if (!data) return {};

  if (Array.isArray(data)) {
    return data.reduce((acc, item) => {
      if (item && item.name) {
        acc[item.name] = { value: !!item.value };
      }
      return acc;
    }, {} as NormalizedFeatureFlags);
  }

  return Object.keys(data).reduce((acc, key) => {
    const entry = data[key];
    if (entry && typeof entry === 'object' && 'value' in entry) {
      acc[key] = { value: !!entry.value };
    } else {
      acc[key] = { value: !!entry };
    }
    return acc;
  }, {} as NormalizedFeatureFlags);
}

export async function fetchFeatureFlags(): Promise<NormalizedFeatureFlags> {
  const raw = await get(`${FEATURE_FLAGS_API_ROOT}/featureFlag/status`);

  return normalize(raw);
}

export async function enableFeatureFlag(flag: string): Promise<void> {
  await get(`${FEATURE_FLAGS_TOGGLE_API_ROOT}/${flag}/enable`);
}

export async function disableFeatureFlag(flag: string): Promise<void> {
  await get(`${FEATURE_FLAGS_TOGGLE_API_ROOT}/${flag}/disable`);
}
